import React, { useState } from 'react';
import StepForm from './StepForm/StepForm';
import StepDetails from './StepDetails/StepDetails';
import EmailContent from './EmailContent/EmailContent';
import EmailDetails from './EmailDetails/EmailDetails';
import { TaskType } from '@Shared.Angular/flowingly.services/flowingly.constants';
import DecisionGateway from './DecisionGateway/DecisionGateway';
import { ProcessMapNodeCateories } from '@Shared.Angular/@types/core/contracts/queryModel/flowModels/processMapNodeCateories';
import StepTags from './StepTags/StepTags';
import { useService } from '@Client/runner.hooks/useService';
import { SharedAngular } from '@Client/@types/sharedAngular';
import { IProcessMapNodeDetailsViewModel } from '../LeftPanel/ProcessMap/ProcessMap';
import CustomTabs from '@Shared.Angular/flowingly.components/CustomTabs/CustomTabs';

import NamedAvatar from './NamedAvatar/NamedAvatar';
import CustomTabPanel from '@Shared.Angular/flowingly.components/CustomTabs/CustomTab/CustomTabPanel';

type Props = {
  selectedNode: IProcessMapNodeDetailsViewModel;
};

const RightPanel = (props: Props) => {
  const { selectedNode } = props;

  const appConfig = useService<SharedAngular.APP_CONFIG>('APP_CONFIG');

  const decisionGateway = selectedNode?.decisionGateway;
  const stepName = selectedNode && selectedNode.stepName;
  const stepAssignee = selectedNode && selectedNode.stepActor;

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setSelectedTabIndex(newValue);
  };

  const getTabsConfig = () => {
    if (selectedNode?.stepType === TaskType.CUSTOM_EMAIL) {
      return {
        tabs: [{ label: 'Recipients' }, { label: 'Template' }],
        tabPanels: [{ component: EmailDetails }, { component: EmailContent }],
        headerData: [{ title: 'Step Name', value: stepName }],
        defaultTab: 1
      };
    }
    if (selectedNode?.category === ProcessMapNodeCateories.DecisionGateway) {
      return {
        tabPanels: [{ component: DecisionGateway }],
        headerData: [
          {
            title: 'Decision Name',
            value: decisionGateway?.name || 'Not Specified'
          }
        ],
        defaultTab: 0
      };
    }
    return {
      tabs: [
        { label: 'Step Details' },
        { label: 'Step Form' },
        ...(appConfig.enableTagging ? [{ label: 'Tags' }] : [])
      ],
      tabPanels: [
        { component: StepDetails },
        { component: StepForm },
        { component: StepTags }
      ],
      headerData: [
        {
          title: 'Step Assignee',
          value: stepAssignee,
          showAvatar: true
        },
        { title: 'Step Name', value: stepName }
      ],
      defaultTab: 1
    };
  };

  const { tabs, tabPanels, headerData, defaultTab } = getTabsConfig();
  const [selectedTabIndex, setSelectedTabIndex] = useState(defaultTab);

  return (
    <div id="process-map-rightpanel">
      <div className={'process-map-v2-view-right-panel-header-container'}>
        {headerData.map((headerItem) => (
          <div
            className="process-map-v2-view-right-panel-header-row"
            key={headerItem.title}
          >
            <div className="process-map-v2-view-right-panel-header-label-cell">
              {headerItem.title}
            </div>
            <div className="process-map-v2-view-right-panel-header-content-cell">
              {headerItem.showAvatar ? (
                <NamedAvatar fullName={headerItem.value} />
              ) : (
                <p>{headerItem.value}</p>
              )}
            </div>
          </div>
        ))}
      </div>
      {tabs?.length > 0 ? (
        <CustomTabs
          selectedTabIndex={selectedTabIndex}
          onChange={handleChange}
          tabs={tabs}
        />
      ) : (
        <div className="process-map-v2-view-tabpanel-notabs-container"></div>
      )}
      {tabPanels.map(({ component: Component }, index) => (
        <CustomTabPanel key={index} value={selectedTabIndex} index={index}>
          <Component selectedNode={selectedNode} />
        </CustomTabPanel>
      ))}
    </div>
  );
};

export default RightPanel;
